import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { MatOverlayService } from "src/app/services/mat-overlay.service";
import { ProfileComponent } from "./profile/profile.component";
import { Perfil } from "src/app/modules/admin/types/Perfil";
import { Button } from "protractor";
import { link } from "fs";
import { ChristmasService } from "src/app/services/christmas.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private overlayService: MatOverlayService,
    private christmasService: ChristmasService
  ) {}
  nomeUsuario!: string;
  lotacaoUsuario!: string;
  permissaoUsuario!: string;
  nomeModulo!: string;
  siglaModulo!: string;

  user: any;
  perfil: any;
  isOpen = false;
  isChristmasMode: boolean = false;

  navItems: any[] = [];

  ngOnInit() {
    this.isChristmasMode = this.christmasService.isChristmasMode();
    this.user = JSON.parse(localStorage.getItem("user") ?? "null");

    const perfilStorage = localStorage.getItem("perfil");

    if (!perfilStorage || perfilStorage === "undefined" || perfilStorage === "null") {
      console.error("Perfil não encontrado no localStorage. Redirecionando para seleção de módulos...");
      this.router.navigate(["/modulos"]);
      return;
    }

    try {
      this.perfil = JSON.parse(perfilStorage);
      this.nomeModulo = this.perfil.desc_modulo;
      this.siglaModulo = this.perfil.sigla;
    } catch (error) {
      console.error("Erro ao fazer parse do perfil:", error);
      this.router.navigate(["/modulos"]);
      return;
    }

    if (this.user) {
      this.nomeUsuario = this.user.nome;
      this.lotacaoUsuario = this.user.lotacao;
      this.permissaoUsuario = this.perfil.desc_perfil;
    } else {
      alert("Usuário não encontrado!");
      this.router.navigate(["/"]);
      return;
    }

    switch (this.siglaModulo) {
      case "TAC":
        this.montarPerfilTAC();
        break;
      case "PAD":
        this.montarPerfilPAD();
        break;
      case "SIND":
        this.montarPerfilSIND();
        break;
      case "TCA":
        this.montarPerfilTCA();
        break;
      case "API":
        this.montarPerfilAPI();
        break;
      case "MED":
        this.montarPerfilMED();
        break;
      case "TAC2":
        this.montarPerfilTAC2();
        break;
      case "SGU":
        this.montarPerfilSGU();
        break;
      case "PPI":
        this.montarPerfilPPI();
        break;
      default:
        break;
    }
  }
  montarPerfilTAC() {
    this.navItems.push({
      type: "menu",
      nome: "TAC",
      icon: "gavel",
      menuItems: [
        {
          nome: "Cadastrar",
          icon: "add_circle",
          link: "tac/createtac",
        },
        {
          nome: "Consultar/Alterar",
          icon: "search",
          link: "tac/followtac",
        },
        {
          nome: "Incluir Documentos",
          icon: "upload_file",
          link: "tac/listprocessosinclusaodocumentos",
        },
        {
          nome: "Incluir Declarações",
          icon: "description",
          link: "tac/listprocessosinclusaodeclaracoes",
        },
      ],
    });
    this.navItems.push({
      type: "button",
      nome: "Painel",
      icon: "dashboard",
      link: "tac/dash",
    });
    this.navItems.push({
      type: "button",
      nome: "Comunicados",
      icon: "announcement",
      link: "tac/comunicados",
    });
    this.navItems.push({
      type: "link",
      target: "_blank",
      nome: "Manual",
      icon: "menu_book",
      link: "../../../assets/files/manual-tac.pdf",
    });

    this.navItems.push({
      type: "menu",
      nome: "Declarações",
      icon: "description",
      menuItems: [
        {
          nome: "Emitir Declaração",
          icon: "edit_document",
          link: "tac/emitir-declaracao",
        },
        {
          nome: "Verificar autenticidade",
          icon: "verified",
          link: "/public/verificar-autenticidade",
        },
      ],
    });

    this.navItems.push({
      type: "link",
      target: "_blank",
      nome: "Tacômetro",
      icon: "analytics",
      link: "https://app.powerbi.com/view?r=eyJrIjoiNTMwZWIwNmYtN2ZkZC00MWNhLWJmZGYtMTM4YmM0MzA5ZGIxIiwidCI6IjY3ZmQ0MzFjLWIyYWQtNDg2Ny04MWJjLWQ3NTYyMjBiNTZkNCJ9",
    });

  }
  montarPerfilPAD() {
    this.navItems.push({
      type: "button",
      nome: "PADs",
      icon: "folder",
      link: "pad",
    });
    this.navItems.push({
      type: "menu",
      nome: "Declarações",
      icon: "description",
      menuItems: [
        {
          nome: "Emitir Declaração",
          icon: "edit_document",
          link: "pad/emitir-declaracao",
        },
        {
          nome: "Verificar autenticidade",
          icon: "verified",
          link: "/public/verificar-autenticidade",
        },
      ],
    });
    this.navItems.push({
          type: "menu",
          nome: "Manual Técnico",
          icon: "book_4",
          menuItems: [
            {
              type: "link",
              target: "_blank",
              nome: "E-manual",
              icon: "assignment",
              link: "manual/emanual-pad",
            },
            {
              type: "link",
              target: "_blank",
              nome: "Tire suas Dúvidas",
              icon: "quiz",
              link: "https://notebook.google.com/notebook/997078bb-3e2c-443b-9079-58d0a38f8f6e/preview",
            },
            {
              type: "dialog",
              nome: "Fale conosco - E-mail",
              icon: "forward_to_inbox",
              mensagem: "Para dúvidas ou sugestões encaminhe um e-mail para corregedoriageral@goias.gov.br.",
            },
          ],
        });
  }
  montarPerfilSIND() {
    if (this.perfil.codg_perfil == Perfil.ADMINISTRADOR) {
      this.navItems.push(
        {
          type: "button",
          nome: "Sindicâncias",
          icon: "assignment",
          link: "sind/list",
        },
        {
          type: "menu",
          nome: "Painel",
          icon: "dashboard",
          menuItems: [
            {
              nome: "Geral",
              icon: "analytics",
              link: "sind/dash",
            },
            {
              nome: "Administrativo",
              icon: "admin_panel_settings",
              link: "sind/dashAdmin",
            },
          ],
        },
        {
          type: "menu",
          nome: "Relatórios",
          icon: "assessment",
          menuItems: [
            {
              nome: "Histórico de Processos",
              icon: "description",
              link: "sind/relatorio-historico",
            },
            {
              nome: "Sindicâncias Públicas",
              icon: "public",
              link: "/public/sindicancias",
            },
          ],
        },
        {
          type: "menu",
          nome: "Sindicômetro",
          icon: "analytics",
          menuItems: [
            {
              type: "link",
              target: "_blank",
              nome: "Geral",
              icon: "bar_chart",
              link: "https://app.powerbi.com/view?r=eyJrIjoiNTc1OGNkZmUtZmFjOS00MWYzLWIwNjgtNzVlMGNhYTQ1ZjBmIiwidCI6IjY3ZmQ0MzFjLWIyYWQtNDg2Ny04MWJjLWQ3NTYyMjBiNTZkNCJ9",
            },
            {
              type: "link",
              target: "_blank",
              nome: "Administrativo",
              icon: "admin_panel_settings",
              link: "https://app.powerbi.com/view?r=eyJrIjoiZTRmZWRhMjItMjU2YS00OTYyLTk4YTMtZjYzNGFlZWVkNWY2IiwidCI6IjY3ZmQ0MzFjLWIyYWQtNDg2Ny04MWJjLWQ3NTYyMjBiNTZkNCJ9",
            },
          ],
        },
        {
          type: "menu",
          nome: "Manual Técnico",
          icon: "book_4",
          menuItems: [
            {
              type: "link",
              target: "_blank",
              nome: "E-manual",
              icon: "assignment",
              link: "manual/emanual-sind",
            },
            {
              type: "link",
              target: "_blank",
              nome: "Checklist",
              icon: "select_check_box",
              link: "manual/checklist-sindicancia",
            },
            {
              type: "link",
              target: "_blank",
              nome: "Tire suas Dúvidas",
              icon: "quiz",
              link: "https://notebook.google.com/notebook/997078bb-3e2c-443b-9079-58d0a38f8f6e/preview ",
            },
            {
              type: "link",
              target: "_blank",
              nome: "Guia Completo",
              icon: "dictionary",
              link: "../../../assets/files/guia-completo-sindicancia.pdf",
            },
          ],
        }
      );
    } else {
      this.navItems.push(
        {
          type: "button",
          nome: "Sindicâncias",
          icon: "assignment",
          link: "sind/list",
        },
        {
          type: "button",
          nome: "Painel",
          icon: "dashboard",
          link: "sind/dash",
        },
        {
          type: "menu",
          nome: "Relatórios",
          icon: "assessment",
          menuItems: [
            {
              nome: "Histórico de Processos",
              icon: "description",
              link: "sind/relatorio-historico",
            },
            {
              nome: "Sindicâncias Públicas",
              icon: "public",
              link: "/public/sindicancias",
            },
          ],
        },
        {
          type: "link",
          target: "_blank",
          nome: "Sindicômetro",
          icon: "analytics",
          link: "https://app.powerbi.com/view?r=eyJrIjoiNTc1OGNkZmUtZmFjOS00MWYzLWIwNjgtNzVlMGNhYTQ1ZjBmIiwidCI6IjY3ZmQ0MzFjLWIyYWQtNDg2Ny04MWJjLWQ3NTYyMjBiNTZkNCJ9",
        },
        {
          type: "menu",
          nome: "Manual Técnico",
          icon: "book_4",
          menuItems: [
            {
              type: "link",
              target: "_blank",
              nome: "E-manual",
              icon: "assignment",
              link: "manual/emanual-sind",
            },
            {
              type: "link",
              target: "_blank",
              nome: "Checklist",
              icon: "select_check_box",
              link: "manual/checklist-sindicancia",
            },
            {
              type: "link",
              target: "_blank",
              nome: "Tire suas Dúvidas",
              icon: "quiz",
              link: "https://notebook.google.com/notebook/997078bb-3e2c-443b-9079-58d0a38f8f6e/preview ",
            },
            {
              type: "link",
              target: "_blank",
              nome: "Guia Completo",
              icon: "dictionary",
              link: "../../../assets/files/guia-completo-sindicancia.pdf",
            },
          ],
        }
      );
    }
  }
  montarPerfilTCA() {
    this.navItems.push({
      type: "button",
      nome: "Painel",
      icon: "dashboard",
      link: "tca",
    });
    this.navItems.push({
      type: "button",
      nome: "TCA",
      icon: "assignment",
      link: "tca/list",
    });
    this.navItems.push({
      type: "menu",
      nome: "Relatórios",
      icon: "assessment",
      menuItems: [
        {
          nome: "TCA's Públicas",
          icon: "public",
          link: "/public/tca",
        },
      ],
    });

  }

  montarPerfilAPI() {
    this.navItems.push(
      {
        type: "button",
        nome: "Painel",
        icon: "dashboard",
        link: "api/dash",
      },
      {
        type: "button",
        nome: "API's",
        icon: "code",
        link: "api/list",
      }
    );
  }

  montarPerfilMED() {
    this.navItems.push({
      type: "button",
      nome: "Mediação",
      icon: "mediation",
      link: "med/list",
    });
    if (this.perfil.id_perfil == 1) {
      this.navItems.push(
        {
          type: "button",
          nome: "Painel",
          icon: "dashboard",
          link: "med/dash",
        }
      );
    }
  }
  montarPerfilTAC2() {
    this.navItems.push({
      type: "button",
      nome: "TAC",
      icon: "gavel",
      link: "tac2/list",
    });

    this.navItems.push({
      type: "button",
      nome: "Painel",
      icon: "dashboard",
      link: "tac2/dash",
    });
  }

  montarPerfilSGU() {
    this.navItems.push({
      type: "button",
      nome: "Dashboard",
      icon: "dashboard",
      link: "sgu/dashboard",
    });

    this.navItems.push({
      type: "menuHover",
      nome: "Paineis",
      icon: "view_quilt",
      menuItems: [
        {
          nome: "Painel Público",
          icon: "public",
          link: "/public/sgu-comissoes",
        },
      ],
    });
    this.navItems.push({
      type: "menuHover",
      nome: "Gerenciar",
      icon: "settings",
      menuItems: [
        {
          nome: "Gerenciar Usuários",
          icon: "people",
          link: "sgu/usuarios",
        },
        {
          nome: "Gerenciar Comissões",
          icon: "groups",
          link: "sgu/comissoes",
        },
        {
          nome: "Gerenciar Autoridades",
          icon: "admin_panel_settings",
          link: "sgu/autoridades",
        },
        {
          nome: "Gerenciar Unidades",
          icon: "business",
          link: "sgu/unidades",
        },
      ],
    });
  }

  montarPerfilPPI() {
    this.navItems.push({
      type: "button",
      nome: "PPI",
      icon: "assignment",
      link: "ppi",
    });
  }

  toggleProfileOverlay(event) {
    if (this.overlayService.isOpen()) {
      this.closeProfileOverlay();
    } else {
      this.openProfileOverlay(event);
    }
  }

  openProfileOverlay(event: MouseEvent) {
    this.overlayService.open(ProfileComponent, event.target);
  }

  closeProfileOverlay() {
    this.overlayService.close();
  }
}
